class DhuniBottomNav extends HTMLElement {
  connectedCallback() {
    this.lastScrollY = window.scrollY;
    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;

    window.requestAnimationFrame(() => {
      const currentY = window.scrollY;
      const delta = currentY - this.lastScrollY;

      if (Math.abs(delta) > 4) {
        if (delta > 0 && currentY > 80) {
          this.classList.add('is-compact');
        } else {
          this.classList.remove('is-compact');
        }
        this.lastScrollY = currentY;
      }

      this.ticking = false;
    });
  }
}

if (!customElements.get('dhuni-bottom-nav')) {
  customElements.define('dhuni-bottom-nav', DhuniBottomNav);
}

// The store's cart type is "drawer", but the drawer should only ever be
// used on mobile: the desktop header cart icon should navigate to /cart as
// normal, and add-to-cart shouldn't pop the drawer open on desktop either.
// Patching CartDrawer.prototype.open (rather than only binding our own
// click handlers) covers every path that calls it, including the
// auto-open after a successful add-to-cart. customElements.whenDefined
// avoids a race with cart-drawer.js regardless of script load order.
(() => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

  customElements.whenDefined('cart-drawer').then(() => {
    const CartDrawer = customElements.get('cart-drawer');
    const originalOpen = CartDrawer.prototype.open;

    CartDrawer.prototype.open = function (triggeredBy) {
      if (isDesktop()) {
        if (triggeredBy && triggeredBy.href) window.location.href = triggeredBy.href;
        return;
      }
      return originalOpen.call(this, triggeredBy);
    };

    document.querySelectorAll('[data-dhuni-cart-link]').forEach((link) => {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', (event) => {
        event.preventDefault();
        cartDrawer.open(link);
      });
    });
  });
})();
